(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mb-cart-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mb-cart-countdown')) {
    class MbCartCountdown extends HTMLElement {
      connectedCallback() {
        this.output = this.querySelector('[role="timer"]');
        this.storageKey = 'nord-wien-cart-countdown-v1';
        this.duration = 600000;
        this.itemCount = Number(this.dataset.cartCount) || 0;
        this.expiresAt = this.readDeadline();
        this.onChange = (event) => {
          const count = event.detail && event.detail.cartCount;
          if (count !== undefined) this.itemCount = Number(count) || 0;
          if (this.itemCount === 0) {
            this.expiresAt = 0;
            try { localStorage.removeItem(this.storageKey); } catch (e) {}
            clearInterval(this.interval);
            this.output.textContent = '10:00';
          } else {
            this.sync();
          }
        };
        this.onOpen = () => this.sync();
        this.onStorage = (event) => {
          if (event.key === this.storageKey) {
            this.expiresAt = this.readDeadline();
            this.renderTime();
          }
        };
        document.addEventListener('theme:cart:change', this.onChange);
        document.addEventListener('theme:cart-drawer:open', this.onOpen);
        window.addEventListener('storage', this.onStorage);
        this.sync();
      }
      disconnectedCallback() {
        clearInterval(this.interval);
        document.removeEventListener('theme:cart:change', this.onChange);
        document.removeEventListener('theme:cart-drawer:open', this.onOpen);
        window.removeEventListener('storage', this.onStorage);
      }
      readDeadline() {
        try {
          const value = Number(localStorage.getItem(this.storageKey));
          return Number.isFinite(value) && value > 0 ? value : 0;
        } catch (e) {
          return this.expiresAt || 0;
        }
      }
      restart() {
        this.expiresAt = Date.now() + this.duration;
        try { localStorage.setItem(this.storageKey, String(this.expiresAt)); } catch (e) {}
      }
      sync() {
        if (!this.itemCount) return;
        this.expiresAt = this.readDeadline() || this.expiresAt;
        if (!this.expiresAt || this.expiresAt <= Date.now()) this.restart();
        clearInterval(this.interval);
        this.renderTime();
        this.interval = setInterval(() => this.renderTime(), 1000);
      }
      renderTime() {
        if (this.itemCount && this.expiresAt && this.expiresAt <= Date.now()) this.restart();
        const remaining = this.expiresAt ? Math.max(0, Math.ceil((this.expiresAt - Date.now()) / 1000)) : 600;
        const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
        const seconds = String(remaining % 60).padStart(2, '0');
        this.output.textContent = `${minutes}:${seconds}`;
      }
    }
    customElements.define('mb-cart-countdown', MbCartCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mb-cart-tiers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mb-cart-tiers')) {
    class MbCartTiers extends HTMLElement {
      connectedCallback() {
        if (!this.placed()) {
          if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.placed(), { once: true });
          return;
        }
        if (this.ready) return;
        this.ready = true;
        this.tiers = (this.dataset.tiers || '').split(',').map((p) => {
          const [q, d] = p.split(':').map(Number);
          return { qty: q, pct: d };
        }).filter((t) => t.qty && t.pct).sort((a, b) => a.qty - b.qty);
        this.msg = this.querySelector('[data-tiers-msg]');
        this.fill = this.querySelector('[data-tiers-fill]');
        this.steps = [...this.querySelectorAll('[data-tiers-step]')];
        this.steps.forEach((step, i) => {
          const tier = this.tiers[i];
          if (!tier) { step.hidden = true; return; }
          step.querySelector('[data-tiers-pct]').textContent = tier.pct + ' %';
        });
        this.onChange = (e) => {
          const c = e.detail && e.detail.cartCount;
          if (c !== undefined) this.render(Number(c) || 0); else this.refresh();
        };
        this.onOpen = () => this.refresh();
        document.addEventListener('theme:cart:change', this.onChange);
        document.addEventListener('theme:cart-drawer:open', this.onOpen);
        this.render(Number(this.dataset.count) || 0);
      }
      placed() {
        // live outside the items holder so cart updates don't remove it
        const drawer = this.closest('#cart-drawer') || document.getElementById('cart-drawer');
        const holder = drawer && drawer.querySelector('[data-items-holder]');
        if (!holder) return false;
        if (holder.previousElementSibling === this) return true;
        const old = holder.previousElementSibling;
        if (old && old.tagName === 'MB-CART-TIERS') old.remove();
        holder.before(this);
        return false;
      }
      refresh() {
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
          .then((r) => r.json()).then((c) => this.render(c.item_count || 0)).catch(() => {});
      }
      kusy(n) { return 'Stück'; }
      render(count) {
        const tiers = this.tiers;
        if (!tiers.length) return;
        const next = tiers.find((t) => count < t.qty);
        if (next) {
          const missing = next.qty - count;
          const reached = [...tiers].reverse().find((t) => count >= t.qty);
          this.msg.innerHTML = (reached ? 'Sie erhalten <span class="mbct__green">' + reached.pct + ' % Rabatt</span>. ' : '') +
            'Noch <b>' + missing + ' ' + this.kusy(missing) + '</b> bis <span class="mbct__green">' + next.pct + ' % Rabatt</span>';
        } else {
          this.msg.innerHTML = 'Glückwunsch! Sie erhalten <span class="mbct__green">' + tiers[tiers.length - 1].pct + ' % Rabatt</span>';
        }
        const n = tiers.length;
        let done = 0;
        this.steps.forEach((step, i) => {
          const isDone = tiers[i] && count >= tiers[i].qty;
          step.classList.toggle('is-done', !!isDone);
          if (isDone) done = i + 1;
        });
        let pct = 0;
        if (done >= n) pct = 100;
        else {
          const prevQty = done ? tiers[done - 1].qty : 0;
          const nextQty = tiers[done].qty;
          const part = Math.max(0, Math.min(1, (count - prevQty) / (nextQty - prevQty)));
          const startPos = done ? ((done - 0.5) / n) * 100 : 0;
          const endPos = ((done + 0.5) / n) * 100;
          pct = startPos + (endPos - startPos) * part;
        }
        this.fill.style.width = pct + '%';
      }
    }
    customElements.define('mb-cart-tiers', MbCartTiers);
  }
  } catch(e) { console.error(e); }
})();

})();
